





























import { Component, Model, Vue } from "vue-property-decorator";

@Component
class PaymentMethodSelect extends Vue {
  @Model("change") method!: string;

  dialog = false;

  get methods() {
    return [
      {
        label: this.$t("trade.cash-in.debit-card"),
        value: "debit-card",
        disabled: false,
        icon: require("../../../../assets/images/icon_debit_card.svg")
      },
      {
        label: "Apple Pay",
        value: "apple-pay",
        disabled: false,
        icon: require("../../../../assets/images/icon_apple_pay.svg")
      }
      // {
      //   label: "Google Pay",
      //   value: "google-pay",
      //   disabled: true,
      //   icon: require("../../../../assets/images/icon_google_pay.svg")
      // }
    ];
  }

  get current() {
    const current = this.methods.find(x => x.value === this.method);
    return {
      label: current?.label ?? "",
      value: current?.value ?? ""
    };
  }

  handleSelectMethod(item) {
    this.dialog = false;
    if (!item.disabled) {
      this.$emit("change", item.value);
    }
  }
}
export default PaymentMethodSelect;
